import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/careers/page.tsx");
